import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { facade_a1, facade_a2, iconRavalement, iconLoupe } from '../images/imageImports';
import useSeo from '../hooks/useSeo';
import './PeinturePage.css';

const RavalementPage = () => {
  const [selectedPhoto, setSelectedPhoto] = useState(null);
  
  // Empêcher le scroll de l'arrière-plan quand la modale est ouverte
  useEffect(() => {
    if (selectedPhoto) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }

    // Nettoyer l'effet au démontage du composant
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [selectedPhoto]);

  useSeo({
    title: 'Ravalement de façade · Vie et couleurs (Couëron)',
    description: 'Ravalement de façade à Couëron - Région nantaise : nettoyage haute pression, peinture toiture et façade, protections hydrofuges. Artisan spécialisé en région nantaise. Devis gratuit.',
    canonical: 'https://vie-et-couleurs.nokram.fr/ravalement'
  });
  return (
    <div className="peinture-page">
      <section className="ravalement-header">
        <div className="container">
          <div>
            <h1 className="page-title">Ravalement de façade</h1>
            <p className="page-subtitle">
              Nettoyage, protection et mise en peinture de vos façades et toitures
            </p>
          </div>
        </div>
      </section>

      <section className="service-section">
        <div className="container">
          <div className="service-content">
            <div className="service-text">
              <h2 className="service-title"><img src={iconRavalement} alt="Ravalement de façade" className="title-icon" />Ravalement de façade</h2>
              <p className="service-description">
                Nous redonnons vie à vos façades et toitures grâce à des méthodes de nettoyage adaptées et des peintures
                techniques (respirantes, hydrofuges) pour une protection durable. Intervention soignée, respect de l’existant
                et finitions nettes.
              </p>
              <div className="service-details">
                <h3>Ravalement et entretien</h3>
                <ul>
                  <li>Nettoyage de façade</li>
                  <li>Nettoyage de toiture</li>
                  <li>Peinture toiture</li>
                  <li>Peinture façade</li>
                </ul>
              </div>
              <div className="service-features">
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Produits adaptés au support (pierre, enduit, ardoise, tuile)</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Protection hydrofuge et anti-mousse longue durée</span>
                </div>
                <div className="feature-item">
                  <span className="feature-icon">✅</span>
                  <span>Finitions homogènes et aspect soigné</span>
                </div>
              </div>
            </div>

            <div className="service-image">
              <div className="image-card">
                <img src={facade_a2} alt="Ravalement de façade - exemple" className="image-cover" />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Réalisations - Avant/Après */}
      <section className="photos-section service-section-alt">
        <div className="container">
          <h2 className="section-title">Nos Réalisations - Avant/Après</h2>
          <div className="photos-grid">
            <div className="photo-card" onClick={() => setSelectedPhoto({
              title: 'Façade',
              description: 'Nettoyage, protection et enduit.',
              beforeSrc: facade_a1,
              afterSrc: facade_a2
            })}>
              <div className="photo-container">
                <div className="photo-before">
                  <img src={facade_a1} alt="Façade - Avant" />
                </div>
                <div className="photo-after">
                  <img src={facade_a2} alt="Façade - Après" />
                </div>
              </div>
              <div className="photo-info">
                <h3>Façade</h3>
                <p>Nettoyage, traitement et mise en peinture.</p>
              </div>
              <div className="photo-overlay">
                <img src={iconLoupe} alt="Zoom" className="zoom-icon" style={{height:'20px', width:'20px'}} />
                <p>Cliquez pour agrandir</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Modal pour afficher les photos en grand */}
      {selectedPhoto && (
        <div className="photo-modal" onClick={() => setSelectedPhoto(null)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="modal-close" onClick={() => setSelectedPhoto(null)}>×</button>
            <div className="modal-photo-container">
              <div className="modal-photo-before">
                <img src={selectedPhoto.beforeSrc} alt={`${selectedPhoto.title} - Avant`} />
              </div>
              <div className="modal-photo-after">
                <img src={selectedPhoto.afterSrc} alt={`${selectedPhoto.title} - Après`} />
              </div>
            </div>
            <div className="modal-info">
              <h3>{selectedPhoto.title}</h3>
              <p>{selectedPhoto.description}</p>
            </div>
          </div>
        </div>
      )}

      {/* CTA Section */}
      <section id="devis" className="cta-section">
        <div className="container">
          <div className="cta-content">
            <h2>Besoin d'un devis pour vos travaux de ravalement ?</h2>
            <p>Contactez-nous pour discuter de votre projet et obtenir une estimation gratuite.</p>
            <Link to="/contact" className="btn btn-primary btn-large">
              Demander un devis
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default RavalementPage;


